export interface IAuthData {
    accessPrivileges?: string ;
    accessToken?: string;
    userName?: string;
    wu?: string[];
    userID?: number;
}

export interface IKey {
    username: string;
    code: string;
}

export interface IKeyRequest {
    username: string;
    choice: string;
}

export enum eLocalStorageItems {
    accessPrivileges = '_accessPrivileges',
    accessToken = '_access_token',
    blockedAgencies = '_blockedAgencies',
    changePasswordRequired = '_changePasswordRequired',
    dbLastUpdate = '_dbLastUpdate',
    homeLocationForUserId = '_homeLocationForUserId_',
    redirectionError = '_redirectionError',
    selectedAgenciesOnMap = '_selectedAgenciesOnMap',
    tempLocationForUserId = '_tempLocationForUserId_',
    userName = '_userName',
    userId = '_userId',
    vds_new_tab_cameras = '_vds_new_tab_cameras',
    wu = '_wu',
    availableCameras = '_availableCameras',
    unavailableCameras = '_unavailableCameras',
    snapshotOnlyCameras = '_snapshotOnlyCameras',
    mobileOnlyCameras = '_mobileOnlyCameras'
}

export enum ePrivileges {
    GeneralVideo = 'Access to Video and Snapshot',
    CameraBlock = 'Camera Block',
    UserConfig = 'User Configuration',
    UserGroupConfig = 'User Groups Configuration',
    RolesConfig = 'Roles Configuration',
    GeneralConfig = 'Camera Attributes Configuration',
    Analytics = 'Analytics',
    VDSConfig = 'Video Distribution Server Configuration',
    Alerts = 'Alerts',
    CameraConfig = 'Camera Configuration',
    NewAccountRequest = 'New Account Request',
    CameraWallConfig = 'Video Wall Configuration',
    CameraWallView = 'Video Wall View',
    CameraExternalWallView = 'External Wall View',
    WallTourConfig = 'Video Wall Tour Configuration',
    WallTourView = 'Video Wall Tour View',
    CameraTourView = 'Camera Tour View',
    CameraTourConfig = 'Camera Tour Configuration',
    ViewEvents = 'View Events',
    ViewWeatherWaterStations = 'View Weather/Water Stations',
    Reports = 'Reports',
    SystemAdmin = 'SystemAdmin',
    WallTourViewOrConfig = 'Video Wall Tour View or Config',
    WallViewOrConfig = 'Video Wall View or Config',
    CameraTourViewOrConfig = 'Camera Tour View or Config',
    Map = 'Map'
}
